export const queryKeyMap = {
  tags: (params?: object) =>
    ['tags', params].filter((item) => item !== undefined),
  globalTags: (params?: object) =>
    ['globalTags', params].filter((item) => item !== undefined),
  localTags: (params?: object) =>
    ['localTags', params].filter((item) => item !== undefined),
};
